import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    formGrid: {
      marginTop: 24,
      '& .MuiSvgIcon-root': { width: 18, height: 18 },
      '& .MuiTypography-body1': {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    buttons: {
      margin: '16px auto',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
    header: { marginBottom: 16 },
    headerText: { fontSize: 14 },
    executedPublications: {
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    limitTextBold: { color: palette.deepBlue },
    limitText: { fontSize: 12 },
    executedPublicationsModal: { padding: '12px 0px' },
    actionsGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '24px 0px',
    },
    seeModelsButtons: {
      color: palette.blue,
      margin: 0,
      borderColor: palette.blue,
    },
    divider: {
      width: '100%',
      marginTop: 22,
    },
  });
